import { GEOSERVER_API } from './BingMap.constants';

export function loadBingApi() {
  const bingMapsScriptTagID = 'bing-maps-script';
  const bingMapsScriptTag = document.getElementById(bingMapsScriptTagID);
  // #genai Element.remove() detaches the same node as body.removeChild()
  if (bingMapsScriptTag) {
    bingMapsScriptTag.remove();
  }
  const callbackName = 'bingAPIReady';
  const url = `https://www.bing.com/api/maps/mapcontrol?callback=${callbackName}`;

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.defer = true;
    script.id = bingMapsScriptTagID;
    script.src = url;
    window.bingAPIReady = () => resolve();
    script.onerror = (error) => {
      // #genai Reject with an Error while keeping the original DOM event as cause (S6671).
      const loadError = new Error('Failed to load Bing Maps script');
      loadError.cause = error;
      reject(loadError);
    };
    document.body.appendChild(script);
  });
}

function clip(n, minValue, maxValue) {
  return Math.min(Math.max(n, minValue), maxValue);
}

function mapSize(zoom) {
  // eslint-disable-next-line no-bitwise
  return 256 << zoom;
}

function tileToLatLong(tileX, tileY, zoom) {
  const tilex = tileX * 256;
  const tiley = tileY * 256;
  const size = mapSize(zoom);
  const x = (clip(tilex, 0, size - 1) / size) - 0.5;
  const y = 0.5 - (clip(tiley, 0, size - 1) / size);

  return {
    latitude: 90 - 360 * (Math.atan(Math.exp(-y * 2 * Math.PI)) / Math.PI),
    longitude: 360 * x,
  };
}

export function parcelLayerUrlConstructor(tile) {
  const topLeftLatLong = tileToLatLong(tile.x, tile.y + 1, tile.zoom);
  const bottomRightLatLong = tileToLatLong(tile.x + 1, tile.y, tile.zoom);

  const boundingBox = `${topLeftLatLong.longitude},${topLeftLatLong.latitude},${bottomRightLatLong.longitude},${bottomRightLatLong.latitude}`;

  return `${GEOSERVER_API}&BBOX=${boundingBox}`;
}

export const createParcelTileLayer = (minZoom) => {
  const { Microsoft } = window;
  const tileSourceOptions = {
    uriConstructor: parcelLayerUrlConstructor,
    minZoom,
  };
  const tileSource = new Microsoft.Maps.TileSource(tileSourceOptions);
  return new Microsoft.Maps.TileLayer({ mercator: tileSource });
};
